export const sorting = {
  sorts: [
    {
      kod: 0,
      nazwa: "ceny",
    },
    {
      kod: 1,
      nazwa: "terminu",
    },
    {
      kod: 2,
      nazwa: "oceny",
    },
    {
      kod: 4,
      nazwa: "popularności",
    },
  ]
};
